import * as types from "./actionTypes";

export interface APIStatusMessageAction {
    type: typeof types.BEGIN_API_CALL | typeof types.API_CALL_ERROR;
}

export function beginApiCall(): APIStatusMessageAction {
    return { type: types.BEGIN_API_CALL };
}

export function apiCallError(): APIStatusMessageAction {
    return { type: types.API_CALL_ERROR };
}
